module.exports = __webpack_public_path__ + "static/media/be.f1e78c8b.svg";